import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { tap, shareReplay } from 'rxjs/operators';

import { EnvironmentName } from '../constants/EnvironmentConst';
import { EnvToggleMap } from '../constants/FeatureToggles';

@Injectable({
  providedIn: 'root',
})
export class FeatureToggleService {
  subscription: Subscription;
  private flags$: Observable<any> | null = null;
  private flags = {};

  constructor(private http: HttpClient) {}

  unsubscribe(): void {
    if (this.subscription) this.subscription.unsubscribe();
  }

  private getFeatureToggles(): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: environment.unleashConfig.clientKey,
      'no-need-for-authorization': 'true',
    });
    const params = new HttpParams().set('appName', EnvironmentName.TB).set('environment', 'default').set('tenantId', environment.tenantId);
    return (this.flags$ = this.http.get(environment.unleashConfig.url, { headers, params }).pipe(
      tap((data) => data['toggles'].forEach((f) => (this.flags[f.name] = true))),
      shareReplay(1)
    ));
  }

  private waitUntilFlagsAreInitialized(): Promise<void> {
    return new Promise((resolve) => {
      const assigned = setInterval(() => {
        if (Object.keys(this.flags).length) {
          clearInterval(assigned);
          resolve();
        }
      }, 100);
    });
  }

  async getFlag(name: string): Promise<boolean> {
    let flag = false;
    if (name) {
      name = name + EnvToggleMap[environment.environmentInstance];
      try {
        if (!this.flags$) await this.getFeatureToggles().toPromise();
        await this.waitUntilFlagsAreInitialized();
        flag = this.flags[name.toString()] || false;
      } catch (err) {
        console.error('Error', err);
      }
    }
    return flag;
  }
}
